import { isConnectedNode } from "@p0security/shared/graph/types";
import { NodeFor } from "@p0security/shared/types/assessment/data/index";
import { List, Typography } from "@p0security/ui";
import { ConditionalVirtualList } from "components/common/ConditionalVirtualList";
import { useMemo } from "react";

import { IdentityLink } from "../../cells/Identity";
import { MemberIdentityDisplay } from "./MemberIdentityDisplay";

const renderGroup = (n: NodeFor<"identity">) => (
  <List.Item>
    <IdentityLink data={{ ...n.data, id: n.key }} type="short" show="grant" />
    &nbsp;
    <MemberIdentityDisplay identity={n.data} />
  </List.Item>
);

export const Groups: React.FC<{ node: NodeFor<"identity"> }> = ({ node }) => {
  const groups = useMemo(
    () =>
      node.children
        .filter(isConnectedNode("identity"))
        .filter((n) => n.data.type === "group"),
    [node]
  );

  return groups.length ? (
    <ConditionalVirtualList<NodeFor<"identity">>
      data={groups}
      renderItem={renderGroup}
    />
  ) : (
    <div>
      <Typography.Text type="secondary">(No groups)</Typography.Text>
    </div>
  );
};
